// import { clsx } from 'clsx';
// import { twMerge } from 'tailwind-merge';

// export function cn(...inputs) {
//   return twMerge(clsx(inputs));
// }

// export function createPageUrl(pageName) {
//   const routes = {
//     'Home': '/',
//     'Marketplace': '/marketplace',
//     'ProductDetail': '/product',
//     'Cart': '/cart',
//     'Checkout': '/checkout',
//     'BuyerOrders': '/orders',
//     'FarmerRegistration': '/farmer/register',
//     'FarmerDashboard': '/farmer/dashboard',
//     'CreateProduct': '/farmer/product/new',
//     'AdminDashboard': '/admin',
//   };

//   if (pageName.includes('?')) {
//     const [page, params] = pageName.split('?');
//     return `${routes[page] || '/'}?${params}`;
//   }

//   return routes[pageName] || '/';
// }

// export function formatCurrency(amount) {
//   return `रू ${amount?.toLocaleString('en-NP') || 0}`;
// }

// export function formatDate(date) {
//   return new Date(date).toLocaleDateString('en-NP', {
//     year: 'numeric',
//     month: 'short',
//     day: 'numeric',
//   });
// }

// export function generateOrderNumber() {
//   return `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`;
// }

/**
 * ============================================
 * UTILITY FUNCTIONS
 * ============================================
 */

import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merge Tailwind CSS classes
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/**
 * Create page URL
 */
export function createPageUrl(pageName) {
  const routes = {
    'Home': '/',
    'Marketplace': '/marketplace',
    'ProductDetail': '/product',
    'Cart': '/cart',
    'Checkout': '/checkout',
    'BuyerOrders': '/orders',
    'FarmerRegistration': '/farmer/register',
    'FarmerDashboard': '/farmer/dashboard',
    'CreateProduct': '/farmer/product/new',
    'AdminDashboard': '/admin',
    'PrivacyPolicy': '/privacy',
    'TermsOfService': '/terms',
    'AboutUs': '/about',
    'ContactUs': '/contact',
    'support': '/support',
    'SupportCenter': '/support',
  };

  // Handle query params
  if (pageName.includes('?')) {
    const [page, params] = pageName.split('?');
    return `${routes[page] || '/'}?${params}`;
  }

  return routes[pageName] || '/';
}

/**
 * Format currency (Nepali Rupees)
 */
export function formatCurrency(amount) {
  return `रू ${amount?.toLocaleString('en-NP') || 0}`;
}

/**
 * Format date
 */
export function formatDate(date) {
  return new Date(date).toLocaleDateString('en-NP', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

/**
 * Generate order number
 */
export function generateOrderNumber() {
  return `ORD-${Date.now()}-${Math.random().toString(36).substr(2, 5).toUpperCase()}`;
}